/**
 * weekly-top-10
 *
 * @author    Richard J. Turner <richard.turner@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */

"use strict";

import tablesort from "tablesort";
import "../common/tablesort_numeric";
import "../common/tablesort_time";

import renderWeeklyReport from "./render-weekly-report";
import removeInitialViewClass from "../common/remove-initial-view-class";

export default dataUrl => sb => {
    let form;
    let selectedPeriod = null;
    let currentData;

    const renderReport = (data, filter) => {
        let report = sb.find("table");
        let body = report.query("tbody");

        hidePleaseWait();
        sb.empty(body).append(body, renderWeeklyReport(data, filter));
        tablesort(report[0]);
        report.css("display", "table");

        sb.notify({type: "tableUpdated"});

        removeInitialViewClass(sb);
    };

    const showPleaseWait = () => {
        let wait = sb.find("div.scroll_datagrid .wait");
        wait.css("display", "block");
    };

    const hidePleaseWait = () => {
        let wait = sb.find("div.scroll_datagrid .wait");
        wait.css("display", "none");
    };

    const onFormSubmit = e => {
        e.preventDefault();

        showPleaseWait();
        sb.postApi(dataUrl, { method: "POST", period: selectedPeriod }).then(
            data => {
                currentData = data;
                return renderReport(currentData);
            }
        );
    };

    return {
        init() {
            form = sb.find("form");

            sb.addEvent(form, "submit", onFormSubmit);

            sb.listen({
                periodsSelectionChanged: period => selectedPeriod = period,
                tableFilter: filter => {
                    if (currentData) {
                        renderReport(currentData, filter);
                    }
                }
            });
        },
        destroy() {
            sb.ignore(["periodsSelectionChanged", "tableFilter"]);

            sb.removeEvent(form, "submit", onFormSubmit);

            form = null;
        }
    }
};

